document.addEventListener('DOMContentLoaded', () => {
  const menuGroup = document.querySelector('.header__menu-group');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const slidingNav = document.querySelector('[data-mobile-menu]');
  
  if (menuToggle && slidingNav) {
    menuToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      
      slidingNav.classList.toggle('is-open');
      
      const isOpen = slidingNav.classList.contains('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });

    document.addEventListener('click', (e) => {
      if (!menuGroup.contains(e.target)) {
        slidingNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  const cartToggle = document.querySelector('[data-cart-toggle]');
  
  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = '/cart';
    });
  }

  initProductPage();
  initCart();
});

function initProductPage() {
  const productSection = document.querySelector('[data-product-id]');
  if (!productSection) return;

  const productJson = document.querySelector('[data-product-json]');
  if (!productJson) return;

  const product = JSON.parse(productJson.textContent);
  const variantIdInput = document.querySelector('[data-variant-id]');
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  const priceElement = document.querySelector('[data-product-price]');
  const mainImage = document.querySelector('[data-main-image]');
  const thumbnails = document.querySelectorAll('[data-thumbnail]');
  const optionButtons = document.querySelectorAll('[data-option-btn]');
  const quantityInput = document.querySelector('[data-quantity-input]');
  const quantityMinus = document.querySelector('[data-quantity-minus]');
  const quantityPlus = document.querySelector('[data-quantity-plus]');

  let selectedOptions = {};
  
  if (product.options && product.variants) {
    product.options.forEach((option, index) => {
      selectedOptions[option] = product.variants[0][`option${index + 1}`];
    });
  }

  optionButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const optionName = btn.dataset.optionName;
      const optionValue = btn.dataset.optionValue;
      
      document.querySelectorAll(`[data-option-name="${optionName}"]`).forEach(b => {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      
      const optionValueDisplay = document.querySelector(`[data-option-value="${optionName}"]`);
      if (optionValueDisplay) {
        optionValueDisplay.textContent = optionValue;
      }
      
      selectedOptions[optionName] = optionValue;
      updateVariant();
    });
  });

  function updateVariant() {
    const selectedVariant = product.variants.find(variant => {
      return product.options.every((option, index) => {
        return variant[`option${index + 1}`] === selectedOptions[option];
      });
    });

    if (selectedVariant) {
      variantIdInput.value = selectedVariant.id;
      if (priceElement) {
        priceElement.textContent = formatMoney(selectedVariant.price);
      }
      if (addToCartBtn) {
        if (selectedVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold Out';
        }
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', selectedVariant.id);
      window.history.replaceState({}, '', url);
    }
  }

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImage) {
        mainImage.src = thumb.dataset.mediaSrc;
      }
    });
  });

  if (quantityMinus && quantityPlus && quantityInput) {
    quantityMinus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value) || 1;
      if (current > 1) {
        quantityInput.value = current - 1;
      }
    });
    quantityPlus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value) || 1;
      quantityInput.value = current + 1;
    });
  }

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      const id = formData.get('id') || variantIdInput.value;
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
      
      try {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Adding...';
        await addToCart(id, quantity);
        
        addToCartBtn.textContent = 'Added!';
        
        // Trigger the slide-in notification if it exists
        const notification = document.querySelector('.cart-notification');
        if (notification) {
          notification.classList.add('is-visible');
          
          setTimeout(() => {
            notification.classList.remove('is-visible');
          }, 3000);
        }
        
        // Always reset the button and STAY on the page
        setTimeout(() => {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        }, 3000);
        
      } catch (error) {
        console.error('Add to cart error:', error);
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart (Retry)';
        alert('There was an error adding to the cart. Please refresh and try again.');
      }
    });
  }
}

function initCart() {
  document.querySelectorAll('[data-quantity-change]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const key = e.currentTarget.dataset.key;
      const quantity = parseInt(e.currentTarget.dataset.quantity);
      
      e.currentTarget.style.opacity = '0.5'; 
      await updateCartItem(key, quantity);
    });
  });

  document.querySelectorAll('[data-remove-item]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault(); 
      const key = e.currentTarget.dataset.key;
      
      e.currentTarget.style.opacity = '0.5';
      await updateCartItem(key, 0); 
    });
  });
}

async function addToCart(variantId, quantity = 1) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  });

  if (!response.ok) throw new Error('Failed to add to cart');
  return response.json();
}

async function updateCartItem(key, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    });

    if (!response.ok) throw new Error('Failed to update cart');
    
    window.location.reload(); 
  } catch (error) {
    console.error('Update cart error:', error);
    alert('There was an issue updating your cart. Please try again.');
  }
}
// RESTORED: formatMoney function
function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}